export default class DtoBuilding {
    constructor(obj) {
        this.idInstallation = obj.idInstallation
        this.buildingIndex = obj.buildingIndex
        this.buildingType = obj.buildingType
        this.buildingArea = obj.buildingArea
        this.comment = obj.comment
    }
}
